/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Map_SynergistsInputs */

const en_us2_exercise_sheet_map_synergists = /** @type {(inputs: Exercise_Sheet_Map_SynergistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synergists`)
};

const pt_br2_exercise_sheet_map_synergists = /** @type {(inputs: Exercise_Sheet_Map_SynergistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinergistas`)
};

const es_419_exercise_sheet_map_synergists = /** @type {(inputs: Exercise_Sheet_Map_SynergistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinergistas`)
};

const pt_pt2_exercise_sheet_map_synergists = /** @type {(inputs: Exercise_Sheet_Map_SynergistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinergistas`)
};

const fr_fr2_exercise_sheet_map_synergists = /** @type {(inputs: Exercise_Sheet_Map_SynergistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synergistes`)
};

const de_de2_exercise_sheet_map_synergists = /** @type {(inputs: Exercise_Sheet_Map_SynergistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synergisten`)
};

const it_it2_exercise_sheet_map_synergists = /** @type {(inputs: Exercise_Sheet_Map_SynergistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinergici`)
};

/**
* | output |
* | --- |
* | "Synergists" |
*
* @param {Exercise_Sheet_Map_SynergistsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_map_synergists = /** @type {((inputs?: Exercise_Sheet_Map_SynergistsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Map_SynergistsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_map_synergists(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_map_synergists(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_map_synergists(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_map_synergists(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_map_synergists(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_map_synergists(inputs)
	return en_us2_exercise_sheet_map_synergists(inputs)
});
export { exercise_sheet_map_synergists as "exercise-sheet.map_synergists" }